import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  putModulesModuleID,
  type SaveModuleRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { getModuleDetailQueryKey } from "../Queries/useModuleDetailQuery";

interface UpdateModuleParams {
  moduleID: string;
  data: SaveModuleRequest;
}

export function useUpdateModuleMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(({ moduleID, data }: UpdateModuleParams) =>
    putModulesModuleID(data, moduleID),
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { moduleID }) => {
      queryClient.invalidateQueries({
        queryKey: ["MODULES_QUERY"],
      });
      queryClient.invalidateQueries({
        queryKey: getModuleDetailQueryKey(moduleID),
      });
    },
  });
}
